import { BadgeList } from "atoms";
import type { OpenCallSubmission } from "../types";
import { OpenCallBadgeItem } from "./OpenCallBadgeItem";

type Props = {
  selectedSubmissions: OpenCallSubmission[];
};

function ArtistProfileOpenCallsWon({ selectedSubmissions }: Props) {
  return (
    <BadgeList type="blank">
      {selectedSubmissions.map(({ openCallId, selectedAt }) => (
        <OpenCallBadgeItem
          openCallId={openCallId}
          date={selectedAt}
          key={openCallId}
        />
      ))}
    </BadgeList>
  );
}

export { ArtistProfileOpenCallsWon };
